import {tfWizard, WizardComponent} from "./WizardComponent";
import {tfWizardStep, WizardStep} from "./step/WizardStepComponent";
import {WizardPrevious, wizardPrevious} from "./directives/WizardPrevious";
import {WizardNext, wizardNext} from "./directives/WizardNext";
import {WizardComplete, wizardComplete} from "./directives/WizardComplete";
import {stepFooter, StepFooter} from "./step/footer/WizardStepFooter";
import {wizardCancel, WizardCancel} from "./directives/WizardCancel";
import {wizardFooter, WizardFooter} from "./footer/WizardFooter";

export default angular.module("tfApp.tf-wizard", [])
                      .component(WizardComponent, tfWizard())
                      .component(WizardFooter, wizardFooter())
                      .component(WizardStep, tfWizardStep())
                      .component(StepFooter, stepFooter())
                      .directive(WizardPrevious, wizardPrevious)
                      .directive(WizardNext, wizardNext)
                      .directive(WizardComplete, wizardComplete)
                      .directive(WizardCancel, wizardCancel)
                      .name;
